import { render, staticRenderFns } from "./wechatChange.vue?vue&type=template&id=1f25f7ea&scoped=true"
import script from "./wechatChange.vue?vue&type=script&lang=js"
export * from "./wechatChange.vue?vue&type=script&lang=js"
import style0 from "./wechatChange.vue?vue&type=style&index=0&id=1f25f7ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f25f7ea",
  null
  
)

export default component.exports